

const loaninsuranceentry206 = {
  label: "Loan Insurance Entry",
  pageLabel: "Loan Insurance Entry",
  starting: true,
  url: "ms206",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "branch",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Product",
      //   label: "Branch Code",
      name: "product",
      description: "Select product code"
    },
    {
      inputType: "showdata",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No.",
      label: "Account No.",
      name: "",
      description: "Enter Account No. Text"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Account No",
      label: "",
      name: "accountNo",
      description: "Enter Account No"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Number Of Records",
      label: "Number Of Records",
      name: "",
      description: "Enter Number Of Records"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Number of Records Number",
      label: "",
      name: "numberOfRecords",
      description: "Enter Number of Records Number"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "active",
      description: "Active"
    }
  ],
  history: {
    perPage: 10,
    displayColumns: [
      {
        Header: "Create",
        accessor: "Release"
      },
      {
        Header: "Edit",
        accessor: "firstname"
      },
      {
        Header: "delete",
        accessor: "firstname"
      },
      {
        Header: "FD AMount",
        accessor: "firstname"
      },
      {
        Header: "Opening Date",
        accessor: "firstname"
      },
      {
        Header: "Expiry Date",
        accessor: "firstname"
      },
      {
        Header: "Make Date",
        accessor: "firstname"
      },
      {
        Header: "Mark Amount",
        accessor: "firstname"
      },
      {
        Header: "Mark By",
        accessor: "firstname"
      },
      {
        Header: "Release Date",
        accessor: "firstname"
      },
      {
        Header: "Release by",
        accessor: "firstname"
      }
    ]
  }
};

export default loaninsuranceentry206;
